import type { User } from '../types';

/** Admin SPA routes keyed by normalized path (after /dashboard prefix strip). */
export type AdminDeepLinkPage =
  | 'quotes-contracts'
  | 'thezone-receipt'
  | 'restaurants'
  | 'customer-directory';

/**
 * web2pos.com serves this SPA under /dashboard/* — strip that prefix for in-app routing.
 */
export function adminAppRoutePath(pathname: string): string {
  const p = pathname.replace(/\/$/, '') || '/';
  if (p === '/dashboard') return '/';
  if (p.startsWith('/dashboard/')) {
    const rest = p.slice('/dashboard'.length);
    return rest || '/';
  }
  return p;
}

export function adminDeepLinkPageFromPath(pathname: string): AdminDeepLinkPage | null {
  const routePath = adminAppRoutePath(pathname);
  if (routePath === '/quotes') return 'quotes-contracts';
  if (routePath === '/thezone-receipt') return 'thezone-receipt';
  if (routePath === '/deleted-restaurants') return 'restaurants';
  if (routePath === '/restaurants/customer-directory') return 'customer-directory';
  return null;
}

export function isHqDashboardRole(role: User['role'] | undefined): boolean {
  return role === 'admin' || role === 'distributor' || role === 'dealer';
}

export function forceDashboardUrl(): void {
  if (typeof window === 'undefined') return;
  const path = window.location.pathname.replace(/\/$/, '') || '/';
  if (path === '/dashboard') return;
  window.history.replaceState({}, '', '/dashboard');
}
